<template>
    <div id="map"></div>
</template>

<script>
import L from 'leaflet';
import 'leaflet'
import 'leaflet-draw'
import "leaflet/dist/leaflet.css";
import 'leaflet-draw/dist/leaflet.draw.css'

export default {
  name: 'Drawer',
  props: {
    url: String,
    params: Object
  },
  async mounted() {
      const { width, height } = await this.getImageDimensions(this.url);
      const map = L.map('map', { crs: L.CRS.Simple, minZoom: -2});
      const bounds = [[0,0], [height, width]];
      const image = L.imageOverlay(this.url, bounds).addTo(map);
      map.fitBounds(bounds);
      const drawnItems = L.featureGroup().addTo(map);
      const oldItems = L.geoJSON().addTo(map)

      const res = await  fetch('https://svc-dna.api.owal.io/dna/v1/config/alerts?token=3l0L3Ds98VyZAhy1mZWhJtbyiaLOYBMq&fields=alert_config_id,object_detection_conditions(mask,detectable),description,cameras(uuid,fname,description)');
      const json = await res.json();
      console.log(json.data.filter(a => a.cameras[0].uuid === this.$vnode.key).map(a => a.object_detection_conditions))
      const latlngs = json.data
          .filter(a => a.cameras[0].uuid === this.$vnode.key && a.object_detection_conditions && a.object_detection_conditions.length > 0 && a.object_detection_conditions[0].mask)
          .map(a => ({
                  "type": "Feature",
                  "properties": {
                      "alert_config_id": a.alert_config_id,
                      "description": a.description
                  },
                  "geometry": {
                      "type": "Polygon",
                      "coordinates": [a.object_detection_conditions[0].mask[0][0].map(p => ([(p[0]*width), height-(p[1]*height)]))]
                  }
              }));

      oldItems.addData(latlngs)
      oldItems.eachLayer(l => l.bindPopup(`alert_config_id: ${l.feature.properties.alert_config_id}. Current mask: <pre style="overflow-x: scroll">MULTIPOLYGON(((${l.toGeoJSON().geometry.coordinates[0].map((xy) => ([xy[0] / width, (height - xy[1]) / height].join(" "))).join(",")})))</pre>`))
      L.control.layers({

        }, { 'Existing': oldItems, 'New': drawnItems }, { position: 'topleft', collapsed: false }).addTo(map);
        map.addControl(new L.Control.Draw({
            edit: {
                featureGroup: oldItems,
                poly: {
                    allowIntersection: false
                },
            },
            draw: {
                    polygon: false,
                    rectangle: false,
                    marker: false,
                    polyline: false,
                    circle: false,
                    circlemarker: false,
                }
        }));
        map.addControl(new L.Control.Draw({
            edit: {
                featureGroup: drawnItems,
                poly: {
                    allowIntersection: false
                }
            },
            draw: {
                polygon: {
                    allowIntersection: false,
                    showArea: true,

                },
                marker: false,
                polyline: false,
                circle: false,
                circlemarker: false,
            }
        }));

        map.on(L.Draw.Event.EDITED, (event) => {

            event.layers.eachLayer((l) => {
                const polygon = l.toGeoJSON().geometry.coordinates[0].map((xy) => ([xy[0] / width, (height - xy[1]) / height].join(" "))).join(",");
                this.$emit('edited', {geojson: l.toGeoJSON(), polygon, id: l._leaflet_id, feature: l.feature});
                console.log(l._leaflet_id)
                if (l.feature) {
                    // this means it's an existing polygon that has been edited
                    l.bindPopup(
                        `
                        <p>Copy and paste the following into DataGrip or equivalent:</p><pre style="overflow-x:scroll">UPDATE dna.condition_config SET mask = 'MULTIPOLYGON(((${polygon})))') WHERE alert_config_id = ${l.feature.properties.alert_config_id};<pre>
                        `
                    )
                } else {
                    l.bindPopup(
                `<p>Copy and paste the following into DataGrip or equivalent:</p><pre style="overflow-x:scroll">WITH alert as (INSERT INTO dna.alert_config(domain_uuid, category, camera_set, description) values('ff5088c9-b06e-4bbf-af22-c79ea83d4c69', 'object_detection_alert', '["uuid", "${this.$vnode.key}"]', "Car overstaying (${this.params.spot}") returning id) INSERT INTO dna.condition_config (alert_config_id, detectable_id, minimum_count, minimum_duration, minimum_confidence, expires_after, debounce, maximum_count, mask) select alert.id, ${this.params.detectable_id}, ${this.params.minimum_count}, '${this.params.minimum_duration}', ${this.params.minimum_confidence}, '${this.params.expires_after}', '${this.params.debounce}', ${this.params.maximum_count}, 'MULTIPOLYGON(((${polygon})))' from alert;<pre>`
                    )
                }
            }
            )

      })
        map.on(L.Draw.Event.CREATED, (event) => {
            var layer = event.layer;
            const polygon = layer.toGeoJSON().geometry.coordinates[0].map((xy) => ([xy[0]/width, (height-xy[1])/height].join(" "))).join(",");

            drawnItems.addLayer(layer.bindPopup(
                `<p>Copy and paste the following into DataGrip or equivalent:</p><pre style="overflow-x:scroll">INSERT INTO dna.condition_config (id, alert_config_id, detectable_id, minimum_count, minimum_duration, minimum_confidence, expires_after, debounce, maximum_count, mask) VALUES (default, ${this.params.alert_config_id}, ${this.params.detectable_id}, ${this.params.minimum_count}, ${this.params.minimum_duration}, ${this.params.minimum_confidence}, ${this.params.expires_after}, ${this.params.debounce}, ${this.params.maximum_count}, 'MULTIPOLYGON(((${polygon})))');<pre>`, {maxWidth: 500}
            ));
            this.$emit('created', {geojson: layer.toGeoJSON(), polygon, id: layer._leaflet_id, feature: layer.feature});

        });
  },
    methods: {
      latLngToXY(polygon) {
          // Leaflet's coordinate system has 0,0 at the bottom left corner
          // our coordinate system has 0,0 at the top left so we need to translate it.
          // a [[0,0], [0, height], [width, height], [width, 0], [0,0]] is a polygon in our workd
          //
          // return polygon.map((xy) => ([xy[0], height-xy[1]]))
          return false
      },
      XYToLatLng(polygon) {
        return false
      },
      absoluteToRelative(polygon, {width, height}) {
          return false
      },
      relativeToAbsolute(polygon, {width, height}) {

      },
      async getImageDimensions(url) {
          const img = new Image();
          img.src = url;
          return new Promise((resolve, reject) => {
              img.onload =() => resolve({width: img.width, height: img.height});
              img.onerror = () => reject()
          })
      }
    }
}
</script>

<style>
    #map {
        width: 800px;
        height: 600px;
        float: left;
    }
    .leaflet-marker-icon.leaflet-div-icon.leaflet-editing-icon.leaflet-touch-icon.leaflet-zoom-animated.leaflet-interactive[style] {
     width: 10px !important;
        height: 10px !important;
    }
        pre code {
        overflow-y: hidden;
        display: block;
        line-height: 1.6em;
        font-size: 11px;
        white-space: pre;
        word-wrap: normal;
    }
</style>
